import MonitoringProgress from "./components/MonitoringProgress";

const MonitoringStatus = () => {
  return <MonitoringProgress />;
};

export default MonitoringStatus;
